import type { Translations } from './index.js';

/** Czech translations. */
export const cs = {
  // --- Structure panel ---
  'structure.search.placeholder': 'Hledat tabulky / sloupce…',
  'structure.search.clear': 'Vymazat hledání',
  'structure.empty.no_dbml': 'Žádný DBML není načten.',
  'structure.empty.no_matches': 'Žádné výsledky.',
  'structure.section.columns': 'Sloupce',
  'structure.section.relations': 'Relace',
  'structure.pk.title': 'Primární klíč',
  'structure.hide.hide': 'Skrýt z diagramu',
  'structure.hide.show': 'Zobrazit v diagramu',

  // --- Detail panel ---
  'detail.error.heading': 'DBML se nepodařilo zpracovat',
  'detail.empty.no_dbml': 'Žádný DBML není načten.',
  'detail.empty.pick_item': 'Vyberte tabulku nebo výčet ze seznamu.',
  'detail.empty.schema_info': '{parts} v tomto schématu.',
  'detail.count.table': '{count} tabulka',
  'detail.count.tables': '{count} tabulky',
  'detail.count.enum': '{count} výčet',
  'detail.count.enums': '{count} výčty',
  'detail.section.columns': 'Sloupce',
  'detail.col.name': 'Název',
  'detail.col.type': 'Typ',
  'detail.col.flags': 'Vlastnosti',
  'detail.col.default': 'Výchozí',
  'detail.col.note': 'Poznámka',
  'detail.section.indexes': 'Indexy',
  'detail.section.refs_out': 'Odkazuje na',
  'detail.section.refs_in': 'Odkazováno z',
  'detail.enum.kind': 'výčet',
  'detail.section.values': 'Hodnoty',
  'detail.enum.not_referenced': 'Na tento výčet neodkazuje žádný sloupec.',
  'detail.section.used_by': 'Použito v',
  'detail.flag.pk': 'PK',
  'detail.flag.fk': 'FK',
  'detail.flag.unique': 'UNIQUE',
  'detail.flag.auto': 'AUTO',
  'detail.flag.not_null': 'NOT NULL',

  // --- Diagram panel ---
  'diagram.toolbar.zoom_in.label': '+',
  'diagram.toolbar.zoom_in.title': 'Přiblížit',
  'diagram.toolbar.zoom_out.label': '−',
  'diagram.toolbar.zoom_out.title': 'Oddálit',
  'diagram.toolbar.fit.title': 'Přizpůsobit obrazovce',
  'diagram.toolbar.reset.label': '1:1',
  'diagram.toolbar.reset.title': 'Resetovat zoom',
  'diagram.toolbar.export_svg.label': 'SVG',
  'diagram.toolbar.export_svg.title': 'Exportovat SVG',
  'diagram.toolbar.cols.toggle.label': 'Jen FK',
  'diagram.toolbar.cols.toggle.title': 'Zobrazit sloupce, které nejsou součástí žádného vztahu',
  'diagram.toolbar.groups.toggle.title': 'Zobrazit kontejnery skupin',
  'diagram.empty': 'Žádné tabulky k zobrazení.',
  'diagram.export.filename': 'diagram.svg',

  // --- App shell ---
  'app.file_button.title': 'Otevřít soubor .dbml',
  'app.file_button.label': 'Otevřít',
  'app.view.structure': 'Struktura',
  'app.view.detail.table': 'Tabulka',
  'app.view.detail.enum': 'Výčet',
  'app.view.diagram': 'Diagram',
  'app.samples.label': 'Vzorky:',
  'app.file_dropdown.recent': 'Nedávné',
  'app.file_dropdown.samples': 'Vzorky',
  'app.theme.switch_to_light': 'Přepnout na světlý motiv',
  'app.theme.switch_to_dark': 'Přepnout na tmavý motiv',
  'app.dropzone.prompt': 'Přetáhněte soubor {extension} nebo klikněte pro procházení.',
  'app.dropzone.hint': 'Nebo načtěte vzorek z rozevíracího menu vedle tlačítka Otevřít.',
  'app.previous_file': '(předchozí)',
  'app.error.load_url': 'Nepodařilo se načíst {label}: {message}',
  'app.error.parse.title': 'DBML se nepodařilo zpracovat',
  'app.error.parse.close': 'Zavřít',

  // --- Settings dropdown ---
  'app.settings.open': 'Nastavení',
  'app.settings.theme.light': 'Světlý',
  'app.settings.theme.dark': 'Tmavý',
  'app.settings.language.label': 'Jazyk',
  'app.settings.font.mono': 'Mono',
  'app.settings.font.proportional': 'Sans',
  'app.settings.github': 'GitHub',
  'app.settings.github.title': 'Zobrazit zdrojový kód na GitHubu',
} satisfies Translations;
